import T, { t } from '../../common/components/T';
import css from './ActivateAccountModal.module.scss';

export const packageThead = {
    data: [
        {
            type: 'radio',
            name: 'radio'
        },
        {
            type: 'component',
            name: 'name',
            title: <T textName='name' defaultStr='Название' />,
            align: 'left'
        },
        {
            type: 'text',
            title: <T textName='currency_price' defaultStr='Цена в валюте' />,
            name: 'currency_price',
            sort: 'price',
            align: 'left'
        },
        {
            type: 'text',
            title: <T textName='price_in_marketing' defaultStr='Баллы' />,
            name: 'price',
            sort: 'price',
            align: 'left'
        }

        // {
        //     type: 'text',
        //     title: <T textName='scores_PV' defaultStr='Баллов, PV' />,
        //     name: 'scores'
        // },
    ]
};

export const productThead = {
    data: [
        {
            type: 'active-row',
            name: 'activeRow'
        },
        {
            type: 'component',
            name: 'name',
            title: <T textName='name' defaultStr='Название' />,
            align: 'left'
        },
        {
            type: 'text',
            title: <T textName='currency_price' defaultStr='Цена в валюте' />,
            name: 'currency_price',
            sort: 'price'
        },
        {
            type: 'text',
            title: <T textName='price_in_marketing' defaultStr='Баллы' />,
            name: 'price',
            sort: 'price'
        },
        {
            type: 'counter',
            title: <T textName='qty' defaultStr='Кол-во' />,
            name: 'quantity'
        }
        // {
        //     type: 'text',
        //     title: <T textName='scores_PV' defaultStr='Баллов, PV' />,
        //     name: 'scores'
        // },
    ]
};

export const transformPackages = (selectedItems, translation, localUpdate) => (data) => {
    if (!data?.data) {
        return {
            data: []
        };
    }

    const createName = (item) => {
        return (
            <>
                <p className={css.packageName}>{item.name}</p>
                {item?.set_products ? (
                    <div className={css.packageProducts}>
                        {item?.set_products?.map((prod) => (
                            <p key={prod.id}>{`${prod.name} - ${prod.count} ${t('pc', 'шт', 'all', translation)}`}</p>
                        ))}
                    </div>
                ) : null}
            </>
        );
    };

    return {
        ...data,
        data: data.data.map((item) => {
            if (localUpdate) {
                item = item?.item;
            }
            const isActive = selectedItems?.some((pack) => pack.id === item.id);
            return {
                radio: !!isActive,
                name: createName(item),
                currency_price: item?.price?.price_for_currency_formatted,
                price: item?.price?.price_for_client_formatted,
                // scores: item?.price?.scores_for_client_formatted,
                item: item,
                activeRow: !!isActive
            };
        })
    };
};

export const transformProducts = (selectedItems, localUpdate) => (data) => {
    if (!data?.data) {
        return {
            data: []
        };
    }
    return {
        ...data,
        data: data.data.map((item) => {
            if (localUpdate) {
                item = item?.item;
            }

            const isActive = selectedItems?.some((it) => it.id === item?.id);
            return {
                activeRow: !!isActive,
                name: item?.name,
                currency_price: item?.price?.price_for_currency_formatted,
                price: item?.price?.price_for_client_formatted,
                quantity: item?.quantity || 1,
                // scores: item?.price?.price_for_client,
                item: item
            };
        })
    };
};
